export default __webpack_public_path__ + "static/media/hotspot-outer-white.90d4bece.svg";